module.exports = __webpack_public_path__ + "static/media/Genesis-Social-1200x628.c9ebf2e1.jpg";